import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import SelectListComponent from "../SelectListComponent";
import { globalConfig } from "../../../config/config";
// import { useContentObjectContext } from "../contexts/ContentObjectContext";

// const querystring = require("querystring");
const CreateContentDescriptors = () => {
  const [contentDescriptorTypes, setContentDescriptorTypes] = useState([]);
//   const {token,userMetadata}=useAuth()
	const token = globalConfig.hardcoded_header;
//   const history = useHistory();
//   const { currentContentObject } = useContentObjectContext();
  const [entitlements, setEntitlements] = useState([]);
  const [message, setMessage] = useState("");
  const [state, setState] = useState({
    contentDescriptorId: 0,
    contentId: 0, //currentContentObject,
    securityContextId: 0,
    contentDescriptorTypeId: 0,
    serverModuleValueCode: 0,
    contentDescriptorName: "",
    contentDescriptorDescription: "",
    contentDescriptorCdata: "",
    contentDescriptorBdata: "",
    createUser: 0,
    createDate: new Date(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date(),
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  function handleDropDown(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({ ...state, [target.id]: parseInt(target.value) });

    console.log(state);
  }

  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");
    var url = `${globalConfig.apiDatahubUrl}/content-descriptors`;
    console.log(url);
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-descriptors/contentDescriptorId`;
    console.log(idUrl);
    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentDescriptorId = response.data["nextId"];
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentDescriptorId
          );
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      //     console.log(response.data)
      //          .catch(err => {
      //             console.log(err);
      //           });
      console.log("message info - " + message);
      console.log(
        "SetState Message info of DescriptorTypedId:" +
          state.contentDescriptorTypeId
      );
      setState({
        ...state,
        contentDescriptorId: 0,
        contentId: 0,
        securityContextId: 0,
        contentDescriptorTypeId: 0,
        serverModuleValueCode: 0,
        contentDescriptorName: " ",
        contentDescriptorDescription: " ",
        contentDescriptorCdata: "",
        contentDescriptorBdata: "",
        createUser: "",
        createDate: new Date(),
        lastUpdateUser: 0,
        lastUpdateDate: new Date(),
      });
    })
    .catch((x) => {
    });
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-descriptor-types`,
         apiHeader(token)
      )
      .then((res) => {
        const contentDescriptorTypes = res.data;
        console.log(contentDescriptorTypes);
        setContentDescriptorTypes(contentDescriptorTypes);
      })
      .catch((x) => {
      });

    axios
      .get(
        `${globalConfig.systemCodesUrl}/ENTITLEMENTS`,
         apiHeader(token)
      )
      .then((res) => {
        const entitlements = res.data;
        console.log("results", entitlements);
        setEntitlements(entitlements);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });
  };
  function handleRest(event) {
    setState({
      ...state,
      contentDescriptorName: "",
      contentDescriptorDescription: "",
    });
  }

  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Descriptor</h4>			
			<Link to="/breeze/list-content-descriptors">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            readOnly={true}
            id="contentName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentId}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Descriptor Type">
            Descriptor Type
          </label>
          {/* <SelectListComponent entityName ={"system-code-values"} valueFilterColumnName = {"systemCodeId"} valueFilter = {"234"} displayColumnName ={"systemCodeValueValue"} keyColumnName ={"systemCodeValueId"}
				IdName={"contentDescriptorTypeId"}
				TypeId={state.contentDescriptorTypeId}
				handle={handleDropDown}
		/> */}
          <select
            id="contentDescriptorTypeId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentDescriptorTypeId}
            onChange={handleChange}
          >
            {/* <option value="#{contentFacadeForm.contentFacadeTypeSelectList}" /> */}
            <option>Click to make selection</option>
            {contentDescriptorTypes.map(
              ({ contentDescriptorTypeDescr, contentDescriptorTypeId }) => (
                <option
                  key={contentDescriptorTypeId}
                  value={contentDescriptorTypeId}
                >
                  {contentDescriptorTypeDescr}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Descriptor Object">
            Descriptor Object
          </label>
          <input
            id="contentDescriptorName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentDescriptorName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Description">
            Description
          </label>
          <input
            id="contentDescriptorDescription"
            className="form-control input-xlarge col-sm-8"
            cols="60"
            rows="5"
            value={state.contentDescriptorDescription}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Server Module">
            Server Module
          </label>
          {/* <SelectListComponent entityName ={"system-code-values"} valueFilterColumnName = {"systemCodeId"} valueFilter = {"222"} displayColumnName ={"systemCodeValueValue"} keyColumnName ={"systemCodeValueId"}
				IdName ={"serverModuleValueCode"}
				TypeId={state.serverModuleValueCode}
				handle={handleDropDown}
				/> */}
          <select
            id="serverModuleValueCode"
            className="form-control input-xlarge col-sm-8"
            value={state.serverModuleValueCode}
            onChange={handleChange}
          >
            <option value={0}>Select Entitlement </option>
            {entitlements.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <hr />
        <button
          className="btn btn-primary"
          value="Clear"
          type="reset"
          onClick={handleRest}
        >
          Clear
        </button>
        &nbsp;
        <button
          className="btn btn-success"
          value="Create"
          type="reset"
          onClick={handleSubmit}
        >
          Create
        </button>
      </div>
    </form>
  );
};

export default CreateContentDescriptors;
